import React, { Component } from 'react'
import { Input,Item } from 'scorpion-core';
import { Field } from 'redux-form';
import Check from '@material-ui/icons/Check';
import ArvorePermissoesGeral from '../../../../../modules/permissoes/components/ArvorePermissoesGeral';

import View from 'react-flexbox'
export default class PerfilForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { permissoes } = this.props;
    return (
      <View column >
        <Item >
          <Field name="nome" placeholder="Nome" component={Input} />
        </Item>
        <Item >
          <Field name="email" placeholder="Email" disabled={true} component={Input} />
          {this.props.initialValues && this.props.initialValues.emailVerified && <Check />}
        </Item>

        <Item >
          <Field name="empresa" placeholder="Empresa" component={Input} />
        </Item>
        <Item >
          <Field name="endereco" placeholder="Endereço" component={Input} />
        </Item>
        <Item >
          <Field name="telefone" placeholder="Telefone" component={Input} />
        </Item>
        {this.props.perfilUser && this.props.perfilUser.tipo === 'admin' &&
          <Item >
            <Field name="permissoesPerfil" label="Permissões Gerais" component={ArvorePermissoesGeral} />
          </Item>
        }


      </View>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/components/PerfilForm/PerfilForm.js